var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { APPEvent } from "@/events/AppEvents";
import { Apphandler } from "@/ipc/MainAppHandler";
import { action, makeObservable, observable } from "mobx";
export class ActiveContactStore {
    constructor() {
        this.contactid = "";
        this.loading = false;
        this.creatingchat = false;
        this.publishing = false;
        this.showpublishbtn = false;
        this.showdeletebtn = false;
        this.connecting = false;
        this.showconnectbtn = false;
        this.showpendingres = false;
        this.contactpublishable = false;
        this.activecontactid = "";
        this.selectedcontact = new Map();
        this.invitationtab = false;
        this.showmessagescreen = false;
        makeObservable(this);
        APPEvent.addSubscriberForConnectResponse((res) => {
            var _a;
            if (!res) {
                APPEvent.publishApperror("Sorry, failed to connect with " + ((_a = this.contact) === null || _a === void 0 ? void 0 : _a.name) + " Please try again later");
            }
            else {
                this.setShpwPendingRes(true);
            }
            this.setShowConnectBtn(false);
            this.setConnecting(false);
        });
        APPEvent.addSubscriberForContactPublishResponse((res) => {
            if (!res) {
                alert("Sorry, failed to publish your contact to organisation directory. Please make sure you have right permission to perform this action");
            }
            else {
                this.setShowPublishBtn(false);
            }
            this.setPublishing(false);
        });
        APPEvent.addSubscriberForContactPublishableRes((res) => {
            if (res) {
                this.setShowPublishBtn(true);
            }
        });
    }
    showMessageScreen(show) {
        this.showmessagescreen = show;
    }
    setInvitationTab(tab) {
        console.log('hereeeee');
        this.invitationtab = tab;
    }
    setContactPublishable(res) {
        this.contactpublishable = res;
    }
    setShpwPendingRes(res) {
        this.showpendingres = res;
    }
    addSelectedContact(user) {
        this.selectedcontact.clear();
        this.selectedcontact.set(user.id, user);
    }
    setActiveContactId(contactid) {
        this.activecontactid = contactid;
    }
    setConnecting(conn) {
        this.connecting = conn;
    }
    setShowDeleteBtn(show) {
        this.showdeletebtn = show;
    }
    setShowConnectBtn(show) {
        this.showconnectbtn = show;
    }
    setShowPublishBtn(show) {
        this.showpublishbtn = show;
    }
    setPublishing(publishing) {
        this.publishing = publishing;
    }
    setCreatingChat(cr) {
        this.creatingchat = cr;
    }
    setContact(con) {
        this.contact = con;
        if (con.publish !== undefined && con.publish) {
            this.setShowPublishBtn(true);
        }
        else {
            this.setShowPublishBtn(false);
        }
        if (con.connected) {
            this.setShowConnectBtn(false);
        }
        else if (!con.pendingresponse) {
            this.setShowConnectBtn(true);
        }
        if (con.pendingresponse) {
            this.setShpwPendingRes(true);
        }
        else {
            this.setShpwPendingRes(false);
        }
    }
    setLoading(loading) {
        this.loading = loading;
    }
    async checkContactCanBePublished() {
        if (this.contact === undefined) {
            return;
        }
        const req = {
            id: this.contact.id
        };
        Apphandler.sendMessage("contactpublishable", req);
    }
    async publish() {
        if (this.contact === undefined) {
            return;
        }
        this.setPublishing(true);
        const req = {
            id: this.contact.id
        };
        Apphandler.sendMessage("publish", req);
    }
    async connect() {
        if (this.contact === undefined) {
            return;
        }
        this.setConnecting(true);
        const req = {
            id: this.contact.id
        };
        Apphandler.sendMessage("connect", req);
    }
    reset() {
        this.contactid = "";
        this.loading = false;
        this.contact = undefined;
        this.creatingchat = false;
        this.publishing = false;
        this.showpublishbtn = false;
        this.showdeletebtn = false;
        this.connecting = false;
        this.showconnectbtn = false;
        this.showpendingres = false;
        this.activecontactid = "";
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "contactid", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "loading", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "contact", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "creatingchat", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "publishing", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "showpublishbtn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "showdeletebtn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "connecting", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "showconnectbtn", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "showpendingres", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "contactpublishable", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "activecontactid", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], ActiveContactStore.prototype, "selectedcontact", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "invitationtab", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], ActiveContactStore.prototype, "showmessagescreen", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "showMessageScreen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setInvitationTab", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setContactPublishable", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setShpwPendingRes", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "addSelectedContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setActiveContactId", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setConnecting", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setShowDeleteBtn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setShowConnectBtn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setShowPublishBtn", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setPublishing", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setCreatingChat", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setContact", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "setLoading", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ActiveContactStore.prototype, "reset", null);
